import * as $ from 'jquery';
import * as loadjs from 'loadjs';

declare let google;
type DataTableType = 'number' | 'string' | 'boolean' | 'date' | 'datetime' | 'timeofday';

interface DataTable {
    addRows(data: any);
    addColumn(type: DataTableType, name: string);
    getValue(rowIndex: number, columnIndex: number): any;
};

interface DrawConfig {
    id: string;
    dataTable: DataTable;
    selectUrl?: string;
    options: Object;
}


$(function () {
    var charElems = document.querySelectorAll('[data-gs-chart]');
    if (charElems.length > 0) {
        loadjs(['https://www.gstatic.com/charts/loader.js'], {
            success: function () {
                function drawHelper(config: DrawConfig, chartFunc) {
                    let elem = document.getElementById(config.id);
                    if (!elem) {
                        return;
                    }

                    let chart = new chartFunc(elem);
                    if (config.selectUrl) {
                        google.visualization.events.addListener(chart, 'select', () => {
                            let selectedItem = chart.getSelection()[0];
                            if (selectedItem) {
                                let row = selectedItem.row;
                                if (row >= 0) {
                                    let name = config.dataTable.getValue(row, 0);
                                    let url = encodeURIComponent(name);
                                    window.open(url, '_blank');
                                }
                            }
                        });
                    }
                    chart.draw(config.dataTable, config.options);
                }

                function drawPie(config: DrawConfig) {
                    drawHelper(config, google.visualization.PieChart);
                }

                function drawTable(config: DrawConfig) {
                    drawHelper(config, google.visualization.Table);
                }

                function drawGeoChart(config: DrawConfig) {
                    drawHelper(config, google.visualization.GeoChart);
                }
                $('[data-gs-chart]').each(function () {
                    let id = this.id;
                    let $this = $(this);
                    let chart = $this.data('gsChart');
                    let title = $this.data('gsChartTitle');
                    let options = $this.data('gsChartOptions');
                    let url = $this.data('gsChartUrl');
                    let selectUrl = $this.data('gsSelectUrl');

                    let dataReady = false;
                    let chartLibReady = false;
                    let drawCalled = false;
                    let data;

                    let drawFunc = function () {
                        if (drawCalled) {
                            return;
                        }
                        // only call draw when both ready
                        if (dataReady && chartLibReady) {
                            drawCalled = true;
                            google.charts.setOnLoadCallback(() => {
                                chartLibReady = true;
                                drawFunc();
                            });

                            let dataTable: DataTable = new google.visualization.DataTable();
                            dataTable.addColumn('string', title);
                            dataTable.addColumn('number', 'Count');
                            dataTable.addRows(data);

                            let config: DrawConfig = {
                                id: id,
                                dataTable: dataTable,
                                selectUrl: selectUrl,
                                options: options
                            };
                            if (chart === 'pie') {
                                drawPie(config);
                            } else if (chart === 'geoChart') {
                                drawGeoChart(config);
                            }
                        }
                    }
                    if (url) {
                        $.getJSON(url, (jsonData) => {
                            data = jsonData;
                            dataReady = true;
                            drawFunc();
                        });
                    } else {
                        if (window["gsChartData"] && window["gsChartData"][id]) {
                            data = window["gsChartData"][id];
                            dataReady = true;
                            drawFunc();
                        }
                    }

                    google.charts.load('current', {
                        packages: ['corechart', 'geochart'], callback: () => {
                            chartLibReady = true;
                            drawFunc();
                        }
                    });

                });
            }
        });
    }
});